import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import List from "./List";
import styles from "../NotesPage.module.scss";

const Body = ({ notesAll, notesArchive, setNotes }) => {
  const { t } = useTranslation('common');
  return (
    <div className={styles["note-app__body"]}>


      <List label={t('notes.your_notes')} setNotes={setNotes} notes={notesAll} />

      <List label={t('notes.archive')} setNotes={setNotes} notes={notesArchive} />
    </div>
  );
};

export default Body;
